import dayjs from 'dayjs';
import {
  ITicketDetailsInterface,
  ITicketPostInterface,
  ITicketPostUpdateViewModel,
  ITicketViewModel,
} from 'Interfaces/ITicketConfig';
import { calculateTicketPostBilling } from './calculateTicketPostBilling';
import { mergeEmailSources } from './mergeEmailSources';

export const ConvertToPutTicketPost = (
  ticketPost: ITicketPostInterface,
  ticket: ITicketViewModel | ITicketDetailsInterface,
  user: any
) => {
  console.log('ticketpost: ticketPost', ticketPost);
  // 1. Bygg toEmail / ccEmail av ticketPost.ticketPost.toEmailList
  const toEmail = mergeEmailSources(ticketPost.ticketPost.toEmailList);

  const ccEmail = mergeEmailSources(ticketPost.ticketPost.ccEmailList);
  // 2. Resten av objektet
  let _ticketPost: ITicketPostUpdateViewModel = {
    id: ticketPost.ticketPost?.id ?? 'new',
    ticketId: ticketPost.ticket.id,
    status: ticketPost.ticketPost.status,
    startTime: dayjs(ticketPost.ticketPost.startTime), // Send local time, no UTC conversion
    endTime: dayjs(ticketPost.ticketPost.endTime), // Send local time, no UTC conversion
    startDeduction: null, // Send local time
    endDeduction: null, // Send local time
    isBillable: ticketPost.ticketPost.isBillable,
    isOvertime: ticketPost.ticketPost.isOvertime, // Send Overtime, no UTC conversion conversionoverTime,
    isBilled: false,
    internal: ticketPost.ticketPost.internal,
    isInHouse: ticketPost.ticketPost.isInHouse,
    isEmailSent: ticketPost.ticketPost.isEmailSent,
    isCCSent: ticketPost.ticketPost.isCCSent,
    ccEmail: ccEmail || '',
    toEmail: toEmail || '',
    direction: 1,
    authorId: ticketPost.ticketPost.author?.id ?? '',
    receiverId: ticketPost.ticket?.contact?.id ?? '',
    changedById: user.id,
    message: ticketPost.ticketPost.message || '',
    originalMessage: ticketPost.ticketPost.originalMessage || '',
    attachments: null,
    workRoleId: ticketPost.ticketPost.workRole?.id
      ? ticketPost.ticketPost.workRole?.id
      : null,
    ticketPostBilling: calculateTicketPostBilling(ticketPost, ticket),
    isApp: false,
  };
  console.log('ticketpost: ticketPost', _ticketPost);
  return _ticketPost;
};
